/**
 * FormHeader Component
 *
 * Header/hint text for form steps.
 */

import React from "react";
import styles from "./FormHeader.module.css";

export interface FormHeaderProps {
  /** Header text */
  children: React.ReactNode;
  /** Test ID */
  "data-testid"?: string;
}

export const FormHeader: React.FC<FormHeaderProps> = ({
  children,
  "data-testid": testId,
}) => {
  return (
    <p className={styles.formHeader} data-testid={testId}>
      {children}
    </p>
  );
};

FormHeader.displayName = "FormHeader";

export default FormHeader;
